export default __webpack_public_path__ + "6dbf59dde51904a386eef6f9f6a247a7.png";